<template>
  <div class="wutuList margin-t60">
    <div class="bt">
      <h3>成果展示</h3>
      <span>ACHIEVEMENT DISPLAY</span>
      <img src="../assets/img/icon_bt.png" alt="">
	</div>
    <ul>
      <li
        v-for="(item, index) in cgzsList"
        :key="item.ID"
        @mouseenter="hoverRoll(item)"
        class="wow fadeInLeft"
        :data-wow-delay="index / 4 + 's'"
      >
        <router-link
          :to="item.Url"
          :href="item.Url"
          @click.native="OpenLink(item.Url)"
        >
          <div class="textBox">
            <p class="title txt-cut1">{{ item.Title }}</p>
			<span class="txt-cut2">{{ item.Describe }}</span>
          </div>
          <div class="time">
            <p>{{ setTimeformat(item.ShowTime, "dd") }}</p>
			<span>{{ setTimeformat(item.ShowTime, "yyyy-mm") }}</span>
          </div>
        </router-link>
      </li>
    </ul>
	<div v-if="moreLink" class="more wow zoomIn" data-wow-delay="0.3s">
      <router-link :to="moreLink"><em>查看更多></em></router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "cgzs",
  props: {
    cgzsList: {
      type: Array,
      default: () => [],
    },
    moreLink: {
      type: String,
      default: "",
    },
  },
  methods: {
    setTimeformat(_data, _format = "yyyy-mm-dd") {
      return _format
        .replace(/YYYY/i, _data.substr(0, 4))
        .replace(/MM/i, _data.substr(5, 2))
        .replace(/DD/i, _data.substr(8, 2));
    },
    hoverRoll(_data) {
      this.item = _data;
    },
  },
};
</script>
<style lang='less' scoped>
.wutuList {
  ul {
  width: 100%;
  height: auto;
  display: inline-block;
  vertical-align: top;
  box-sizing: border-box;
  li {
  width: 100%;
  height: 1.5rem;
  background-color: #fafafa;
  box-sizing: border-box;
  padding: 0.27rem 0.3rem;
  margin-bottom: 0.2rem;
  &:last-child {
	margin-bottom: 0rem;
	}
	a {
	display: flex;
	flex-wrap: nowrap;
	justify-content: space-between;
		.time{
			display: block;
			width: 1.2rem;
			position: relative;
			&::before{
				content: "";
				width: 0.01rem;
				height: 100%;
				background-color: #d9d9d9;
				position: absolute;
				left: 0rem;
				top: 0rem;
			}
			p{
				font-size: 0.4rem;
				font-weight: normal;
				font-stretch: normal;
				line-height: 0.6rem;
				letter-spacing: 0.04rem;
				color: #999999;
				display: inline-block;
				margin-left: 0.45rem;
			}
			span{
				display: block;
				font-size: 0.2rem;
				font-weight: normal;
				font-stretch: normal;
				line-height: 0.26rem;
				letter-spacing: 0.02rem;
				color: #999999;
				text-align: right;
			}
		}
		.textBox {
			p{
				width: 4rem;
				display: block;
				font-size: 0.26rem;
				font-weight: normal;
				font-stretch: normal;
				line-height: 0.28rem;
				letter-spacing: 0.03rem;
				color: #333333;
				margin-bottom: 0.1rem;
			}
			span{
				width: 4.7rem;
				font-size: 0.24rem;
				font-weight: normal;
				font-stretch: normal;
				line-height: 0.3rem;
				letter-spacing: 0.02rem;
				color: #666666;
			}
		}
	}
   }
  }
  .more{
	width: 2rem;
	height: 0.7rem;
	border-radius: 0.05rem;
	border: solid 0.01rem #0376be;
	display: block;
	margin: 0 auto;
	margin-top: 0.4rem;
	margin-bottom: 0.5rem;
	box-sizing: border-box;
	a{
		display: block;
		font-size: 0.26rem;
		font-weight: normal;
		font-stretch: normal;
		line-height: 0.68rem;
		letter-spacing: 0.03rem;
		color: #0376be;
		text-align: center;
	}
  }
}
</style>


// WEBPACK FOOTER //
// src/components/cgzs.vue